<template>
  <div class="text-paster">
    <Steps
      :title="$t('edit.injectInfo.addText')"
      :isShowArrow="true"
      :isLast="true"
      displayType
      @clickBack="onClickBack"
      @onClickFinish="onClickFinish"
    >
      <template slot="body">
        <a-textarea :placeholder="$t('common.inputHolder')" auto-size :rows="2" v-model="pasterObj.content" />
      </template>
    </Steps>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import Steps from "../../Steps.vue";

export default {
  components: { Steps },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      pasterObj: {
        type: "word",
        paster_id: "paster" + uuidv4(),
        ath: "",
        atv: "",
        content: "",
      },
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          this.pasterObj = value;
        }
      },
      immediate: true,
      deep: true,
    },
    newPasterObj: {
      handler: function (val, oldVal) {
        if (val.ath == "" && val.atv == "") {
          const vh = getSceneViewAt();
          this.pasterObj.ath = vh.hlookat;
          this.pasterObj.atv = vh.vlookat;
        }
        this.$emit("change", this.pasterObj, oldVal);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    newPasterObj() {
      return this.$deepClone(this.pasterObj);
    },
  },
  mounted() {
    this.$bus.$on("updatePaster", (e) => {
      if (e.paster_id == this.pasterObj.paster_id) {
        this.pasterObj.ath = e.ath;
        this.pasterObj.atv = e.atv;
      }
    });
  },
  methods: {
    onClickBack() {
      this.$emit("onClickBack", this.pasterObj);
    },
    onClickFinish() {
      this.$emit("saveDataToStore", {
        key: this.pasterObj.paster_id,
        data: this.pasterObj,
      });
    },
  },
};
</script>

<style lang="less" scoped>
// .text-paster {
//   padding: 5px 10px;
// }
</style>